module.exports = __webpack_public_path__ + "media/images/landing/client_Universal-351223a364768f3671456b4e982d985c.png";